@use "../../../global/temporary-mercury-overrides/tab.scss" as *;

:host {
  display: grid;
  block-size: 100%;
  overflow: auto;
  grid-template-rows: 1fr;
}

.web-apps,
.native-apps,
.apis {
  padding-block-start: 16px;
  overflow: auto;
  block-size: 100%;
}

// WA: Add scrollbar styling for ch-tab-render until Mercury provides proper support
.tab::part(page) {
  scrollbar-width: thin;
}

// WA: Apply spacing body to tab slots, instad of the whole component.
// TODO: Resolve this on Mercury, with some addition class maybe.
.spacing-body,
:host(.spacing-body) {
  > ch-tab-render > .tab-slot-spacing-body {
    padding-block: var(--spacing-body-block-start) var(--spacing-body-block-end);
    padding-inline: var(--spacing-body-inline-start)
      var(--spacing-body-inline-end);
  }
}
